import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DeviceLink, UpdateProfileInput } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig } from '@/libraries/react-query';

export const updateDeviceLinkProfile = ({
  slug,
  expectedProfile,
}: UpdateProfileInput): Promise<DeviceLink> => {
  return axios.patch(`/device-tracker/links/${slug}/profile`, { expectedProfile });
};

type UseUpdateDeviceLinkProfileOptions = {
  config?: MutationConfig<typeof updateDeviceLinkProfile>;
};

export const useUpdateDeviceLinkProfile = ({
  config = {},
}: UseUpdateDeviceLinkProfileOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...config,
    mutationFn: updateDeviceLinkProfile,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['device-tracker'] });
      config.onSuccess?.(...args);
    },
  });
};
